<template>
  <div class="no-licence" style="position: relative !important">
    <div class="wrap-editor">
      <froala
        id="edit"
        :tag="'textarea'"
        :config="config"
        v-model="text"
        ref="editorRef"
      ></froala>
    </div>
  </div>
</template>

<script>
import "froala-editor/js/languages/ru";
export default {
  props: {
    value: {},
  },
  watch: {
    text() {
      // let content = document.querySelector(".fr-element");
      // let height = content.offsetHeight;
      // this.page = Math.ceil(height / (21 * this.cm));
      // let mock = document.querySelector("#mockEditor");
      // mock.style.height = `${height}px`;
      // if (height > this.page * 982) {
      //   console.log("breakk");
      //   this.page++;
      // }
    },
  },
  computed: {
    text: {
      get() {
        return this.value || "<span></span>";
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {},
  data() {
    return {
      page: 1,
      cm: 37.795276,
      editor: null,
      config: {
        tableStyles: {
          class1: "No borders",
        },
        embedlyScriptPath: "",
        imageInsertButtons: ["imageUpload", "|", "imageByURL"],
        language: "ru",
        events: {
          "image.beforeUpload": (files) => {
            let editor = this.$refs.editorRef.getEditor();
            if (files.length > 0) {
              let reader = new FileReader();
              reader.onload = (e) => {
                let result = e.target.result;
                editor.image.insert(result, null, null, editor.image.get());
              };
              reader.readAsDataURL(files[0]);
            }
            editor.popups.hideAll();
            return false;
          },
          initialized() {},
        },
        documentReady: true,
        fontSize: [
          "3",
          "4",
          "6",
          "8",
          "9",
          "10",
          "11",
          "12",
          "14",
          "16",
          "18",
          "22",
          "24",
          "30",
          "36",
          "48",
          "60",
          "72",
          "96",
        ],
        fontFamilyDefaultSelection: "Times New Roman",
        // imageUploadRemoteUrls: false,
        toolbarButtons: [
          "fullscreen",
          "bold",
          "italic",
          "underline",
          "strikeThrough",
          "subscript",
          "superscript",
          "textColor",
          "backgroundColor",
          // "|",
          "fontFamily",
          "fontSize",
          // "color",
          // "inlineClass",
          // "inlineStyle",
          // "paragraphStyle",
          "lineHeight",
          "|",
          "paragraphFormat",
          "align",
          "formatOL",
          "formatUL",
          "outdent",
          "indent",
          // "quote",
          // "-",
          // "insertLink",
          "insertImage",
          // "insertVideo",
          //   "embedly",
          //   "insertFile",
          "insertTable",
          "html",
          "|",
          //   "emoticons",
          //   "fontAwesome",
          "specialCharacters",
          // "insertHR",
          // "selectAll",
          // "clearFormatting",
          // "|",
          //   "print",
          //   "getPDF",
          //   "spellChecker",
          // "help",

          //   "|",
          //   "undo",
          //   "redo",
        ],
        charCounterCount: false,
        tabSpaces: 4,
        height: 600,
        fontSizeUnit: "pt",
        language: "ru",
        placeholderText: "",
      },
    };
  },
};
</script>

<style lang="scss">
[data-f-id] {
  display: none !important;
  opacity: 0;
  visibility: hidden;
}
[href*="https://www.froala.com"]
{
  display: none !important;
  opacity: 0;
  visibility: hidden;
}
.vertical-heading p {
  writing-mode: vertical-lr;
  -webkit-writing-mode: vertical-lr;
  -ms-writing-mode: vertical-lr;
  filter: flipH() flipV();
  margin: 0 auto;
}
@media (min-width: 992px) {
  #landscape .fr-box.fr-document .fr-wrapper .fr-element {
    min-height: 21cm !important;
    width: 26cm !important;
  }
}

.wrap-editor {
  .underline-front {
    // background: yellow;
  }
}
.doc-contract .edit-it {
  background: rgb(255, 255, 0);
}
.protocol {
  .kk-wrap {
    width: 110%;
  }
  .kk-item {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    margin-bottom: 10px !important;
    width: 600px !important;
  }
  .kk-left {
    width: 50%;
    padding-right: 20px;
  }
  .kk-right {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-end;
    width: 50% !important;
    flex-shrink: 0;
    word-break: break-word;
    text-align: right;
    float: right !important;
  }
}
[contenteditable="false"] {
  cursor: none !important;
  user-select: none !important;
  pointer-events: none !important;
}
.contract [contenteditable="true"] {
  color: red !important;
}
//
.fr-element .doc-top {
  text-align: right;
  max-width: 300px;
  margin-left: auto !important;
  font-weight: bold;
}
.fr-toolbar.fr-top {
  z-index: 1;
}
.wrap-editor {
  position: relative;
}
.sign-content {
  position: absolute;
  top: 2cm;
  z-index: 5;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12pt;
  .qr {
    width: 50px;
    height: 50px;
    margin-bottom: 15px !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
// hide no-lisense
div.fr-wrapper > div > a {
  opacity: 0;
  pointer-events: none;
}

[data-cmd="fontSize"] {
  span {
    width: 40px !important;
  }
}
.mock-editor {
  position: absolute;
  top: 30px;
  left: 44px;
  right: 47px;
  overflow-y: clip;
  pointer-events: none;
}
.list {
  user-select: none;
  position: absolute;
  left: 0;
  right: 0;
  // border-bottom: 1px dotted var(--ck-color-base-border);
  .page-order {
    position: absolute;
    right: -25px;
    top: 0px;
    background: #c1c1c1;
    width: 20px;
    height: 20px;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    pointer-events: none;
  }
}
.fr-element {
  position: relative;
  overflow-y: clip !important;
}
.fr-wrapper {
  border-left: 1px solid rgba(0, 0, 0, 0.38) !important;
  border-right: 1px solid rgba(0, 0, 0, 0.38) !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.38) !important;
  border-radius: 0px 0px 4px 4px !important;
}
.fr-toolbar {
  border-left: 1px solid rgba(0, 0, 0, 0.38) !important;
  border-right: 1px solid rgba(0, 0, 0, 0.38) !important;
  border-top: 1px solid rgba(0, 0, 0, 0.38) !important;
  border-radius: 4px 4px 0px 0px !important;
}
.fr-element * {
  margin: 0px !important;
  font-size: 14pt;
}

.fr-second-toolbar {
  display: none !important;
}
.fr-quick-insert {
  display: none !important;
}
.fr-sticky-on {
  position: absolute !important;
  /* display: none !important; */
}
.fr-element {
  /* padding: 1cm !important; */
}
.fr-popup {
  z-index: 1052 !important;
}
.fr-box.fr-basic .fr-element.fr-view {
  font-family: "Times New Roman", Georgia, Serif;
  font-size: 18px;
  color: #444444;
}

.fr-element {
  padding: 2cm 1.5cm 2cm 3cm !important;
}
#landscape .fr-element {
  padding: 2cm 1.5cm 2cm 2cm !important;
}
.class1 td,
.class1 th {
  border: none !important;
}
</style>